// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_SideNavbar__BO9fC {
  position: fixed;
  top: 0;
  left: 0;
  height: 100dvh;
  padding: 20px 0;
  background-color: #faf4f2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  z-index: 9;
  transition: all 0.3s;
  max-width: 50px;
  width: 100%;
}
.sidebar_SideNavbar__BO9fC .sidebar_sideTop__Ud6VS {
  max-height: calc(100dvh - 250px);
  overflow-y: auto;
  width: 100%;
  overflow-x: hidden;
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf {
  width: 100%;
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li {
  margin: 4px 0;
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g {
  padding: 8px 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: all 0.3s ease-in-out;
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g .sidebar_linkText__S1fcG {
  font: var(--body-font-two);
  font-weight: 500;
  color: var(--brand);
  margin-left: 10px;
  text-transform: capitalize;
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a img,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a svg,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g img,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g svg,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a img,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a svg,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g img,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g svg {
  width: 20px;
  height: 20px;
  display: inline-block;
  overflow: hidden;
  object-fit: scale-down;
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a:hover, .sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a.sidebar_active__okX-2,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g:hover,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a:hover,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a.sidebar_active__okX-2,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g:hover,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 {
  background-color: var(--brand);
  color: var(--white);
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a:hover img,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a:hover svg, .sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a.sidebar_active__okX-2 img,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a.sidebar_active__okX-2 svg,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g:hover img,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g:hover svg,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 img,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 svg,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a:hover img,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a:hover svg,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a.sidebar_active__okX-2 img,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a.sidebar_active__okX-2 svg,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g:hover img,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g:hover svg,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 img,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 svg {
  filter: invert(1) brightness(4);
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a:hover .sidebar_linkText__S1fcG, .sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li a.sidebar_active__okX-2 .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g:hover .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a:hover .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li a.sidebar_active__okX-2 .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g:hover .sidebar_linkText__S1fcG,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g.sidebar_active__okX-2 .sidebar_linkText__S1fcG {
  color: var(--white);
}
.sidebar_SideNavbar__BO9fC .sidebar_topNav__CsPOP li .sidebar_logoutButton__pBt8g,
.sidebar_SideNavbar__BO9fC .sidebar_bottomNav__ZxDhf li .sidebar_logoutButton__pBt8g {
  background: none;
  border: 0;
  cursor: pointer;
  font: inherit;
  text-align: left;
}
.sidebar_SideNavbar__BO9fC .sidebar_sidebarLogo__w-yhm {
  width: 34px;
  height: 34px;
  background-color: var(--white);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 4px;
  overflow: hidden;
  margin-bottom: 15px;
  margin: 0 auto 15px auto;
}
.sidebar_SideNavbar__BO9fC .sidebar_sidebarLogo__w-yhm img {
  width: 100%;
  height: 100%;
  display: inline-block;
  overflow: hidden;
}
.sidebar_SideNavbar__BO9fC .sidebar_sidebarLogoFull__j5xc5 {
  max-width: 165px;
  width: 100%;
  margin: 0 15px 15px 15px;
  display: block;
}

.sidebar_activeNavItem__H-GLW {
  background-color: var(--brand);
}
.sidebar_activeNavItem__H-GLW img,
.sidebar_activeNavItem__H-GLW svg {
  filter: invert(1) brightness(4);
}
.sidebar_activeNavItem__H-GLW .sidebar_linkText__S1fcG {
  color: var(--white) !important;
}

@media (max-width: 767px) {
  .sidebar_SideNavbar__BO9fC {
    max-width: 0;
    left: -150vw;
  }
  .sidebar_SideNavbar__BO9fC .sidebar_sidebarLogo__w-yhm {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/navbars/sidebar.module.scss"],"names":[],"mappings":"AAAA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;AACD;AACC;EACC,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AACF;AAEC;;EAEC,WAAA;AAAF;AAEE;;EACC,aAAA;AACH;AACG;;;;EAEC,iBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,gCAAA;AAGJ;AADI;;;;EACC,0BAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AAML;AAHI;;;;;;;;EAEC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AAWL;AARI;;;;;;;EAEC,8BAAA;EACA,mBAAA;AAeL;AAbK;;;;;;;;;;;;;;;EAEC,+BAAA;AA4BN;AAzBK;;;;;;;EACC,mBAAA;AAiCN;AA5BG;;EACC,gBAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AA+BJ;AA1BC;EACC,WAAA;EACA,YAAA;EACA,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AA4BF;AA1BE;EACC,WAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;AA4BH;AAxBC;EACC,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,cAAA;AA0BF;;AAtBA;EACC,8BAAA;AAyBD;AAvBC;;EAEC,+BAAA;AAyBF;AAtBC;EACC,8BAAA;AAwBF;;AApBA;EACC;IACC,YAAA;IACA,YAAA;EAuBA;EArBA;IACC,aAAA;EAuBD;AACF","sourcesContent":[".SideNavbar {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 100dvh;\r\n\tpadding: 20px 0;\r\n\tbackground-color: #faf4f2;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-items: flex-start;\r\n\tjustify-content: space-between;\r\n\tz-index: 9;\r\n\ttransition: all 0.3s;\r\n\tmax-width: 50px;\r\n\twidth: 100%;\r\n\r\n\t.sideTop {\r\n\t\tmax-height: calc(100dvh - 250px);\r\n\t\toverflow-y: auto;\r\n\t\twidth: 100%;\r\n\t\toverflow-x: hidden;\r\n\t}\r\n\r\n\t.topNav,\r\n\t.bottomNav {\r\n\t\twidth: 100%;\r\n\r\n\t\tli {\r\n\t\t\tmargin: 4px 0;\r\n\r\n\t\t\ta,\r\n\t\t\t.logoutButton {\r\n\t\t\t\tpadding: 8px 16px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\talign-items: center;\r\n\t\t\t\tjustify-content: flex-start;\r\n\t\t\t\ttransition: all 0.3s ease-in-out;\r\n\r\n\t\t\t\t.linkText {\r\n\t\t\t\t\tfont: var(--body-font-two);\r\n\t\t\t\t\tfont-weight: 500;\r\n\t\t\t\t\tcolor: var(--brand);\r\n\t\t\t\t\tmargin-left: 10px;\r\n\t\t\t\t\ttext-transform: capitalize;\r\n\t\t\t\t}\r\n\r\n\t\t\t\timg,\r\n\t\t\t\tsvg {\r\n\t\t\t\t\twidth: 20px;\r\n\t\t\t\t\theight: 20px;\r\n\t\t\t\t\tdisplay: inline-block;\r\n\t\t\t\t\toverflow: hidden;\r\n\t\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:hover,\r\n\t\t\t\t&.active {\r\n\t\t\t\t\tbackground-color: var(--brand);\r\n\t\t\t\t\tcolor: var(--white);\r\n\r\n\t\t\t\t\timg,\r\n\t\t\t\t\tsvg {\r\n\t\t\t\t\t\tfilter: invert(1) brightness(4);\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.linkText {\r\n\t\t\t\t\t\tcolor: var(--white);\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t.logoutButton {\r\n\t\t\t\tbackground: none;\r\n\t\t\t\tborder: 0;\r\n\t\t\t\tcursor: pointer;\r\n\t\t\t\tfont: inherit;\r\n\t\t\t\ttext-align: left;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.sidebarLogo {\r\n\t\twidth: 34px;\r\n\t\theight: 34px;\r\n\t\tbackground-color: var(--white);\r\n\t\tborder-radius: 50%;\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tcursor: pointer;\r\n\t\tpadding: 4px;\r\n\t\toverflow: hidden;\r\n\t\tmargin-bottom: 15px;\r\n\t\tmargin: 0 auto 15px auto;\r\n\r\n\t\timg {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tdisplay: inline-block;\r\n\t\t\toverflow: hidden;\r\n\t\t}\r\n\t}\r\n\r\n\t.sidebarLogoFull {\r\n\t\tmax-width: 165px;\r\n\t\twidth: 100%;\r\n\t\tmargin: 0 15px 15px 15px;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n\r\n.activeNavItem {\r\n\tbackground-color: var(--brand);\r\n\r\n\timg,\r\n\tsvg {\r\n\t\tfilter: invert(1) brightness(4);\r\n\t}\r\n\r\n\t.linkText {\r\n\t\tcolor: var(--white) !important;\r\n\t}\r\n}\r\n\r\n@media (max-width: 767px) {\r\n\t.SideNavbar {\r\n\t\tmax-width: 0;\r\n\t\tleft: -150vw;\r\n\r\n\t\t.sidebarLogo {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SideNavbar": `sidebar_SideNavbar__BO9fC`,
	"sideTop": `sidebar_sideTop__Ud6VS`,
	"topNav": `sidebar_topNav__CsPOP`,
	"bottomNav": `sidebar_bottomNav__ZxDhf`,
	"logoutButton": `sidebar_logoutButton__pBt8g`,
	"linkText": `sidebar_linkText__S1fcG`,
	"active": `sidebar_active__okX-2`,
	"sidebarLogo": `sidebar_sidebarLogo__w-yhm`,
	"sidebarLogoFull": `sidebar_sidebarLogoFull__j5xc5`,
	"activeNavItem": `sidebar_activeNavItem__H-GLW`
};
export default ___CSS_LOADER_EXPORT___;
